import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiRequest } from '../hooks/useApi.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import { useAnnouncer } from '../contexts/AnnouncerContext.jsx'

export default function RegisterScreen() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const { announce, alertSR } = useAnnouncer()

  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  function clearErrors() {
    setErrors({})
  }

  function validate() {
    const next = {}
    if (!username.trim() || username.length < 3) {
      next.username = 'O nome de usuário deve ter no mínimo 3 caracteres.'
    }
    if (!email.trim()) {
      next.email = 'O e-mail é obrigatório.'
    }
    if (!password || password.length < 6) {
      next.password = 'A senha deve ter no mínimo 6 caracteres.'
    }
    if (password !== confirmPassword) {
      next.confirmPassword = 'As senhas não conferem.'
    }
    return next
  }

  async function handleSubmit(e) {
    e.preventDefault()
    clearErrors()

    const validation = validate()
    if (Object.keys(validation).length > 0) {
      setErrors(validation)
      alertSR('Por favor, corrija os erros no formulário de registro.')
      return
    }

    setSubmitting(true)
    try {
      await apiRequest('POST', '/auth/register', { username, email, password }, false)
      const loginData = await apiRequest('POST', '/auth/login', { username, password }, false)
      login(loginData.access_token)
      announce('Conta criada com sucesso. Bem-vindo!')
      navigate('/menu')
    } catch (err) {
      alertSR(`Erro no registro: ${err.message}`)
      setErrors({ username: err.message })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <section aria-labelledby="register-heading">
      <h2 id="register-heading" tabIndex="-1">Criar uma conta</h2>
      <form id="register-form" noValidate onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="register-username">Nome de usuário</label>
          <input
            type="text"
            id="register-username"
            name="username"
            required
            minLength={3}
            maxLength={50}
            autoComplete="username"
            aria-describedby="register-username-error"
            placeholder="Mínimo 3 caracteres"
            value={username}
            onChange={(e) => { setUsername(e.target.value); if (errors.username) setErrors(p => ({ ...p, username: '' })) }}
            aria-invalid={errors.username ? 'true' : undefined}
          />
          <span id="register-username-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.username || ''}
          </span>
        </div>

        <div className="form-group">
          <label htmlFor="register-email">E-mail</label>
          <input
            type="email"
            id="register-email"
            name="email"
            required
            autoComplete="email"
            aria-describedby="register-email-error"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => { setEmail(e.target.value); if (errors.email) setErrors(p => ({ ...p, email: '' })) }}
            aria-invalid={errors.email ? 'true' : undefined}
          />
          <span id="register-email-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.email || ''}
          </span>
        </div>

        <div className="form-group">
          <label htmlFor="register-password">Senha</label>
          <input
            type="password"
            id="register-password"
            name="password"
            required
            minLength={6}
            autoComplete="new-password"
            aria-describedby="register-password-error"
            placeholder="Mínimo 6 caracteres"
            value={password}
            onChange={(e) => { setPassword(e.target.value); if (errors.password) setErrors(p => ({ ...p, password: '' })) }}
            aria-invalid={errors.password ? 'true' : undefined}
          />
          <span id="register-password-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.password || ''}
          </span>
        </div>

        <div className="form-group">
          <label htmlFor="register-confirm-password">Confirmar senha</label>
          <input
            type="password"
            id="register-confirm-password"
            name="confirm_password"
            required
            minLength={6}
            autoComplete="new-password"
            aria-describedby="register-confirm-password-error"
            placeholder="Confirme sua senha"
            value={confirmPassword}
            onChange={(e) => { setConfirmPassword(e.target.value); if (errors.confirmPassword) setErrors(p => ({ ...p, confirmPassword: '' })) }}
            aria-invalid={errors.confirmPassword ? 'true' : undefined}
          />
          <span id="register-confirm-password-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.confirmPassword || ''}
          </span>
        </div>

        <button type="submit" className="btn btn-primary" id="register-submit" disabled={submitting}>
          Criar conta
        </button>
      </form>

      <p className="form-toggle">
        Já tem conta?{' '}
        <button type="button" className="btn-link" onClick={() => navigate('/login')}>
          Fazer login
        </button>
      </p>
    </section>
  )
}
